module.exports = __webpack_public_path__ + "static/media/Generator-video.8582ee94.webm";


//////////////////
// WEBPACK FOOTER
// ./src/videos/Generator-video.webm
// module id = 123
// module chunks = 0